import React from 'react';

// import React, { useContext, useState } from 'react';
// import { UserContext } from '../context';
// import { DropDownActions } from '../actions';

export const DeluxeTools = () => {
  // const { user } = useContext(UserContext);
  // const [userPreference, setUserPreference] = useState('');

  return (
    <>
      {/*
      {(user && user.deluxe) && (
        <div>
          <DropDownActions 
            type='user'
            added={userPreference === 'added'} 
            blocked={userPreference === 'blocked'} 
            addAction={() => setUserPreference('added')}
            blockAction={() => setUserPreference('blocked')}
            removeAction={userPreference ?  () => setUserPreference('') : null}
            tw='mt-2'
          />
        </div>
      )} */}
    </>
  );
};
